import { ConsultantContractGeneratorType } from "../../consultant-contract-generator-type";
import {
  CanDownloadContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  IConsultantContractStrategy
} from "../consultant-contract-strategy";

export class SelfInvoicingContractStrategy implements IConsultantContractStrategy {
  public readonly name = "SelfInvoicingContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return false;
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return ConsultantContractGeneratorType.SelfInvoicingTemplateDataGenerator;
  }

  canEdit(): boolean {
    return false;
  }

  canDuplicate(): boolean {
    return false;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return ctx.tenant === "wcc"
        ? {
            workspaceId: "419741",
            templateId: "12051929"
          }
        : {
            workspaceId: "419741",
            templateId: "10691591"
          };
    }

    if (ctx.env === "production") {
      return ctx.tenant === "wcc"
        ? {
            workspaceId: "457689",
            templateId: "11213611"
          }
        : {
            workspaceId: "406174",
            templateId: "10691036"
          };
    }

    throw new Error("Unhandled env");
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return ctx.tenant !== "wcc";
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId;
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
